import antdRu from "antd/lib/locale-provider/ru_RU";
import appLocaleData from "react-intl/locale-data/ru";
import enMessages from "../locales/en_US.json";
import ruMessages from "../locales/ru_RU.json";

const RuLang = {
  messages: {
    ...enMessages,
    ...ruMessages
  },
  antd: antdRu,
  locale: 'ru',
  data: appLocaleData
};
export default RuLang;
